import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 16.875rem;
  height: 10.625rem;

  margin: 0 auto;
  padding: 1.25rem;

  border-radius: 0.5rem;
`;

export const PaymentMethodDesc = styled.span`
  font-size: 0.875rem;
  text-align: center;
  color: ${Theme.colors.G_1};
`;

export const PaymentMethodInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  padding: 0.625rem 0;
  margin-bottom: 0.75rem;
  width: 100%;
`;

export const PostpaidInfoLink = styled.span`
  font-size: 0.8125rem;
  color: ${Theme.colors.B_3};
  text-decoration: underline;
  cursor: pointer;
  margin-top: 0.25rem;
  display: inline-block;
  &:hover {
    color: ${Theme.colors.B_2};
  }
`;

export const WarningBox = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  padding: 1rem;
  margin-bottom: 1rem;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 0.5rem;
  width: 100%;
`;

export const WarningIcon = styled.span`
  font-size: 1.5rem;
  line-height: 1.2;
  flex-shrink: 0;
`;

export const WarningContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.375rem;
`;

export const PostpaidInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background-color: ${Theme.colors.G_6};
  border-radius: 0.5rem;
  width: 100%;
  min-height: 10rem;
  justify-content: center;
  align-items: center;
  text-align: center;
`;